import EmploymentRecordForm from './EmploymentRecordForm';

export default EmploymentRecordForm;
